import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import useToggleDropdown from "hooks/useToggleDropdown";
import { toast } from "react-toastify";
import DropDownContainer from "components/dropdown/DropDownContainer";
import { DotEle } from "components/dots/dots.styled";
import { pBtnSmall } from "components/main.styled";
import { useTranslation } from "react-i18next";

export default function PrayerWallItem({ item }) {
  const { t } = useTranslation("prayer");

  const navigate = useNavigate();
  const ref1 = useRef(null);
  const [isDropped, setIsDropped] = useToggleDropdown(ref1);
  const [viewFullText, setViewFullText] = useState(false);

  const handleViewText = () => {
    setViewFullText(!viewFullText);
  };

  const handleDotsClick = (e) => {
    e.stopPropagation();
    setIsDropped.toggle(ref1);
  };

  const handleAddPray = (e) => {
    e.stopPropagation();
    setIsDropped.toggle(ref1);
    toast.success(
      t("wall.prayingFor", { name: item.creator.fullName.split(" ")[0] }),
    );
  };

  const handleViewPost = () => {
    navigate(`/posts/${item._id}`);
  };

  return (
    <PrayerWallItemContainer onClick={() => setViewFullText(!viewFullText)}>
      <PWIMain>
        <PrayerWallItemName> {item.creator.fullName} </PrayerWallItemName>

        <PrayerWallItemText>
          {viewFullText
            ? item.postText.text
            : item.postText.textCondensed
              ? item.postText.textCondensed
              : item.postText.text.slice(0, 75) + "..."}
        </PrayerWallItemText>
      </PWIMain>

      <PWIIcon ref={ref1} onClick={handleDotsClick}>
        <MoreVertIcon />
      </PWIIcon>

      {isDropped && (
        <DropDownContainer top={"35px"}>
          <DotEle onClick={handleViewText}>
            {viewFullText ? t("wall.hideFullText") : t("wall.viewFullText")}
          </DotEle>
          <DotEle onClick={handleAddPray}>
            {t("wall.letKnow", { name: item.creator.fullName.split(" ")[0] })}
          </DotEle>
          <DotEle onClick={handleViewPost}>{t("wall.viewPost")}</DotEle>
        </DropDownContainer>
      )}
    </PrayerWallItemContainer>
  );
}

const PWIIcon = styled(pBtnSmall)`
  visibility: hidden;
  width: 30px;
  height: 30px;

  &:hover {
    cursor: pointer;
    background-color: #a3a3a3;
    color: white;
  }
`;
const PrayerWallItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: fit-content;
  margin-bottom: 10px;
  color: var(--lightThemeFontColor);
  padding: 5px;
  border-radius: 5px;
  transition: all 0.5s;
  &:hover {
    cursor: pointer;
    background-color: #ccc;
    color: white;
    /* on hover display PWIIcon */
    ${PWIIcon} {
      visibility: visible;
    }
  }
`;

const PWIMain = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

const PrayerWallItemText = styled.div`
  font-size: 12px;
  text-align: left;
`;

const PrayerWallItemName = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 10px;
`;
